module.exports = __webpack_public_path__ + "static/media/Alba soffa divan 210_3 FS tyg Vogue Winter Moss 11 miljö modell 2024 ny.92bb4584.jpg";